<template>
  <div class="accountManagement">

    <!-- 查询区内容 -->
    <div class="queryArea">
      <el-select v-model="parameter.platform_id" style="margin-right:10px; margin-top:5px" filterable placeholder="请选择平台">
        <el-option
          v-for="item in accoutarr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-model="parameter.subscribe_status" style="margin-right:10px; margin-top:5px" filterable placeholder="请选择状态">
        <el-option
          v-for="item in [{id:1, name: '未知'}, {id: 2, name: '关注'}, {id:3 , name: '取消关注'}]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-input v-model="parameter.nickname" placeholder="用户昵称" style="margin-right:10px; margin-top:5px;width:200px" />
      <!-- <el-input v-model="parameter.openId" placeholder="openId" style="margin-right:10px; margin-top:5px;width:200px" />

      <el-input v-model="parameter.gh_id" placeholder="gh_id" style="margin-right:10px; margin-top:5px;width:200px" /> -->
      <el-input v-model="parameter.keywords" placeholder="openId/gh_id/appid" style="margin-right:10px; margin-top:5px;width:200px" />
      <el-input v-model="parameter.bind_seller" placeholder="绑定销售名称（精准）" style="margin-right:10px; margin-top:5px;width:200px" />
      <el-input v-model="parameter.account_name" placeholder="公众号名称" style="margin-right:10px; margin-top:5px;width:200px" />
      <el-select v-model="parameter.bind_status" style="margin-right:10px; margin-top:5px" filterable placeholder="是否加入个微">
        <el-option
          v-for="item in [{id:0, name: '全部'},{id:1, name: '是'}, {id: 2, name: '否'}]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <el-date-picker
        v-model="subscribe_timewe"
        style="margin-right:10px; margin-top:5px"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="tiwmew"
      />

      <el-button type="primary" icon="el-icon-search" style="margin-right:10px; margin-top:5px" @click="(parameter.page = 1),getDataList()">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" style="margin-right:10px; margin-top:5px" @click="reset">重置</el-button>

    </div>

    <!-- 列表内容 -->
    <div>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData.list"
        border
        tooltip-effect="dark"
        style="width: 100%;margin-top:20px"
      >

        <el-table-column
          prop="id"
          label="Id"
          width="70"
          align="center"
        />
        <el-table-column
          prop="accountName"
          label="公众号"
          width="100"
          align="center"
        />
        <el-table-column
          prop="relationId"
          label="书城ID"
          width="100"
          align="center"
        />
        <!-- <el-table-column
          prop="openId"
          label="openId"
          width="250"
          align="center"
        /> -->
        <el-table-column
          prop="openId"
          label="openId"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              title="openId"
              width="200"
              trigger="hover"
              :content="scope.row.openId"
            >
              <p slot="reference" class="titip">{{ scope.row.openId }}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="platformName"
          label="所属平台"
          width="70"
          align="center"
        />
        <el-table-column
          prop="nickname"
          label="用户昵称"
          width="100"
          align="center"
        />
        <el-table-column
          prop="headPortrait"
          label="用户头像"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <img v-if="scope.row.headPortrait" style="width:50px;height:50px" :src="scope.row.headPortrait" alt="">
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="saleName"
          label="销售名称"
          width="80"
          align="center"
        />
        <el-table-column
          prop="subscribeTimeText"
          label="首次关注时间"
          width="100"
          align="center"
        />
        <el-table-column
          prop="orderTotal"
          label="付费金额(元)"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{ parseFloat((scope.row.orderTotal/100).toFixed(2)) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="lastOrderPayTime"
          label="最后付费时间"
          width="100"
          align="center"
        />
        <el-table-column
          prop="returnProportion"
          label="返现比例(%)"
          width="80"
          align="center"
        />
        <el-table-column
          prop="returnProportion"
          label="返现开关"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.returnSwitch!=0"
              v-model="scope.row.returnSwitch"
              active-text="开"
              inactive-text="关"
              :active-value="1"
              :inactive-value="2"
              @change="changewr($event,scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="subscribeStatusText"
          label="目前关注状态"
          width="100"
          align="center"
        >
          <!-- protected static array $SUBSCRIBE_STATUS_TEXT = [
            self::SUBSCRIBE_STATUS_1 => '未知',
            self::SUBSCRIBE_STATUS_2 => '关注',
            self::SUBSCRIBE_STATUS_3 => '取消关注',
        ]; -->
          <template slot-scope="scope">
            <i v-if="scope.row.subscribeStatus == 1" class="el-icon-warning" />
            <i v-if="scope.row.subscribeStatus == 2" class="el-icon-success defaultr" />
            <i v-if="scope.row.subscribeStatus == 3" class="el-icon-warning defaultrse" />
            {{ scope.row.subscribeStatusText }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="340">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-button type="success" size="mini" icon="el-icon-picture" @click="addAtlas(scope.row)">赠送图集</el-button>
            <el-button style="margin-top:10px" size="mini" type="danger" icon="el-icon-money" @click="weweimaclickwew(scope.row)">返现红包</el-button>
            <el-button style="margin-top:10px" size="mini" type="primary" icon="el-icon-s-claim" @click="orderlist(scope.row.openId)">订单列表</el-button>
            <el-button style="margin-top:10px" size="mini" type="warning" icon="el-icon-guide" @click="bandwrw(scope.row)">绑定私域销售</el-button>
            <el-button style="margin-top:10px" size="mini" type="info" icon="el-icon-folder-checked" @click="dispose(scope.row.openId)">配置返现比例</el-button>

          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <!-- 弹窗 -->
    <el-dialog
      title="图集"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <Atlas v-if="dialogVisible" :active-item="currentItem" @closer="closer" />
    </el-dialog>
    <el-dialog
      title="预览"
      :visible.sync="dialogVisibledas"
      width="30%"
    >
      <cashdialog ref="lookecahrtimg" />
    </el-dialog>
    <el-dialog
      title="生成二维码"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      width="30%"
    >
      <generate ref="lookecahrtimgrw" @callback="callback" />
    </el-dialog>

    <el-dialog
      title="绑定销售"
      :visible.sync="banddialigsale"
      :destroy-on-close="true"
      width="30%"
    >
      <bandsale ref="bandsale" @clsewrwupdata="clsewrwupdata" />
    </el-dialog>
    <el-dialog
      title="选择返现比例"
      :visible.sync="banddialog"
      :destroy-on-close="true"
      width="20%"
    >
      <diaposedialog ref="diaposedialogview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="订单列表"
      :visible.sync="orderdialog"
      :destroy-on-close="true"
      width="73%"
    >
      <orderlist ref="orderdialogview" />
    </el-dialog>
  </div>
</template>

<script>
import Atlas from './component/atlas.vue'
import bandsale from './component/bandsale.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getUserList, activeyawr } from '@/api/providerAccountManagement/WeChatAccountFans.js'
import generate from '../cashback/components/generate.vue'
import cashdialog from '../cashback/components/cashdialog.vue'
import { strategyPlatform } from '@/api/sourceMaterial.js'
import convertToHump from '@/utils/mixins/convertToHump.js'
import diaposedialog from './component/diaposedialog.vue'
import orderlist from './component/orderlist.vue'
export default {
  name: 'UserList',
  components: {
    Atlas,
    PaginationRight,
    generate,
    cashdialog,
    bandsale,
    diaposedialog,
    orderlist
  },
  mixins: [convertToHump],
  data() {
    return {
      subscribe_timewe: [],
      banddialog: false,
      orderdialog: false,
      parameter: {
        platform_id: null, // 平台id
        nickname: null, // 用户名称
        // openId: null,
        page: 1,
        pageSize: 10,
        subscribe_status: null, // 关注状态  1 未知 2 关注 3取消关注
        // gh_id: null,
        keywords: null,
        bind_seller: null,
        bind_status: 0,
        account_name: null,
        subscribe_time: []
      }, // 参数
      tableData: {}, // 列表数据
      currentItem: null, // 当前选中的图集项
      dialogVisible: false, // 增加图集弹窗
      loading: false,
      accoutarr: [], // 平台
      dialogVisibledas: false,
      dialogVisibler: false,
      banddialigsale: false
    }
  },
  watch: {

  },
  async created() {
    this.getDataList()
    this.getstrategyplatform()
  },
  mounted() {

  },
  methods: {
    establish() {
      this.dialogVisible = true
    },
    addAtlas(item) {
      this.dialogVisible = true
      this.currentItem = item
    },

    // 获取数据列表
    async getDataList() {
      try {
        // this.loading = true
        const data = await getUserList(this.parameter)
        this.tableData = this.convertToHump(data.data)
        // this.loading = false
        console.log(data)
      } catch (error) {
        this.tableData.list = []
        console.log('error', error) // getdata error
      }
    },

    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDataList()
    },

    fetchPageSize(e) {
      this.parameter.pageSize = e
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter = {
        platform_id: null, // 平台id
        nickname: null, // 用户名称
        // openId: null,
        page: 1,
        pageSize: 10,
        subscribe_status: null, // 关注状态  1 未知 2 关注 3取消关注
        // gh_id: null,
        bind_seller: null,
        bind_status: 0,
        account_name: null,
        subscribe_time: [],
        keywords: null
      }
      this.subscribe_timewe = []
      this.getDataList()
    },
    async changewr(index, item) {
      console.log(index, item)
      try {
        const data = await activeyawr({
          open_id: item.openId,
          switch: item.returnSwitch
        })
        console.log('data', data)
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } catch (err) {
        // this.$message({
        //   message: '修改失败',
        //   type: 'erro'
        // })
      }
      this.getDataList()
    },
    closer() {
      this.dialogVisible = false
    },
    weweimaclickwew(item) {
      this.dialogVisibler = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimgrw.sendr(item)
      })
    },
    callback(img) {
      this.dialogVisibler = false
      // this.dialogVisibledas = true
      // this.$nextTick(() => { // 请求成功之后，在这里执行
      //   this.$refs.lookecahrtimg.send(img)
      // })
      this.getDataList()
    },
    bandwrw(item) {
      this.banddialigsale = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.bandsale.sendrw(item)
      })
      console.log('item', item)
    },
    clsewrwupdata() {
      this.banddialigsale = false
      this.getDataList()
    },
    tiwmew(val) {
      console.log('val', val, this.subscribe_timewe)
      // if (!val) {
      //   // this.time为绑定的数据
      //   this.parameter.subscribe_time = []
      // }
      this.parameter.subscribe_time = this.subscribe_timewe
      console.log('subscribe_time', this.parameter.subscribe_time)
    },
    dispose(id) {
      this.banddialog = true
      this.$nextTick(() => {
        this.$refs.diaposedialogview.send(id)
      })
    },
    updata() {
      this.banddialog = false
      this.getDataList()
    },
    orderlist(id) {
      this.orderdialog = true
      this.$nextTick(() => {
        this.$refs.orderdialogview.send(id)
      })
    }
  }
}
</script>
<style scoped lang="less">
.accountManagement{
   padding: 30px 40px;
}

.queryArea{
  display: flex;
  flex-wrap: wrap;
}

// /deep/ .el-input{
//   margin-right: 10px;
// }

// /deep/ .el-input,.el-input__inner{
//   width: 203px;
// }
.titip{
    width: 152px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
